import { useQuery } from '@apollo/client/react';
import { useRef } from 'react';

import { bulkReparseJobQuery } from '../../services/BulkReparseService';
import { NetworkStatus } from '@apollo/client';

const POLL_INTERVAL_MS = 4000;
const IN_PROGRESS_STATUSES = ['pending', 'running'];

export const useBulkReparseJob = (jobId) => {
  const jobRef = useRef(null);
  const { data, loading, error, networkStatus } = useQuery(bulkReparseJobQuery, {
    fetchPolicy: 'cache-and-network',
    pollInterval: jobId ? POLL_INTERVAL_MS : 0,
    skip: !jobId,
    skipPollAttempt: () => {
      const job = jobRef.current;
      return Boolean(job && !IN_PROGRESS_STATUSES.includes(job.status));
    },
    variables: { id: jobId }
  });
  const job = data?.job || null;
  jobRef.current = job;

  const refetching = networkStatus === NetworkStatus.poll;

  return { job, loading: loading && !refetching, error, refetching };
};
